/**
 * Un semáforo verde solo puede nacer de datos reales.
 *
 * Regla dura del §2.6 del diagnóstico: `NO_RECORDS` y `NOT_AVAILABLE` producen
 * semáforo neutro. La plataforma nunca afirma que algo está bien porque no sabe
 * nada de ello.
 */
export function canBeGreen(status) {
    return status === 'REAL' || status === 'MANUAL';
}
/** Etiquetas de presentación por estado. */
export const DATA_STATUS_LABEL = {
    REAL: 'Actualizado',
    PARTIAL: 'Datos parciales',
    NO_RECORDS: 'Sin registros',
    NOT_AVAILABLE: 'No disponible',
    MANUAL: 'Registro manual',
};
//# sourceMappingURL=metric-value.js.map